import React from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/Spinner';
import { context } from '../../../utils';

export const MesssageIsSending: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div data-testid="message-sending">
            <Spinner style={undefined} />
            <p className="text-center">{t('Message is sending...')}</p>
        </div>
    );
};

export const MesssageSent: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="text-center" data-testid="message-already-sent">
            <h3>{t('Message sent')}</h3>
            <p>
                {t('Thanks for your message, we will get back to you shortly.')}
            </p>
        </div>
    );
};

export const ErrorMessage: React.FC = () => {
    const { t } = useTranslation();
    const supportEmail = context['support_email'];
    return (
        <div className="text-center" data-testid="message-error">
            <h4>{t('Error while sending a message.')}</h4>
            <p>
                {t(
                    'Error during send message, please retry later or contact us directly by email'
                )}
                : {supportEmail}.
            </p>
        </div>
    );
};
